import { Style } from 'inlines'
import { Toggle, ToggleOption } from './Toggle'
import { useTranslations } from '@i18n/useLanguage'

type Option = 'yes' | 'no'

export type YesNoToggleProps = {
  yesSelected: boolean
  setYesSelected: (option: boolean) => void
}

export const YesNoToggle = ({
  yesSelected,
  setYesSelected,
}: YesNoToggleProps) => {
  const translations = useTranslations().app.common
  const style: Style = {
    width: '4.125rem',
  }
  const options: ToggleOption<Option>[] = [
    {
      label: translations.yes,
      value: 'yes',
      style: style,
    },
    {
      label: translations.no,
      value: 'no',
      style: style,
    },
  ]
  return (
    <Toggle
      options={options}
      selectedOption={yesSelected ? 'yes' : 'no'}
      setSelectedOption={(option) => setYesSelected(option === 'yes')}
    />
  )
}
